<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br /> {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br /> Date: {{ date }}
        </p>
        <p> RE: Account #: {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }} </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            I recently received a letter from your company in an attempt to collect information to verify a debt. Since your letter states that you’ve actually received my dispute from the credit bureaus regarding this account, then you must already have my social security number, my full name, as well as the full account number and any other pertinent details for this item in which you allege I owe or else you wouldn’t be reporting it. Am I correct? Of course I am. So how can you ask me to HELP you prove that you have made a HUGE mistake?
        </p>
        <p class="letter-content">
            What you should be sending me is a copy of the contract I signed obligating me to this alleged debt. Or how about the proof of identity that I must have provided at the time of incurring this debt – where is it? Proof that you have the legal right to collect this debt would also be nice!
        </p>
        <p class="letter-content">
            You do not have it and so you must remove this account from my credit reports immediately. I have not done any business with you in the past. I do NOT want your business now in the present or in the future and nor do I have to accept it. So therefore, I am submitting this letter to formally state that I REFUSE your claim, DENY your claim, and <strong>SUBMIT FOR FRAUD ANY BUSINESS CLAIMS YOU ALLEGE WE HAVE</strong>. We have no business relationship.
        </p>
        <p class="letter-content">
            Therefore, please cease and desist all collection activity immediately, including any negative reporting to the credit bureaus in which you may have already submitted.
        </p>
        <p class="letter-content">
            If you refuse to do so, I will forward this and all correspondences to my legal counsel for an escalated resolution to this matter.
        </p>
        <p>
            Thank you and I look forward to your resolving this mistake most expeditiously.
            <br />
            <br /> {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br />
            <strong>CC: Federal Trade Commission, 600 Pennsylvania Ave. NW, Washington, DC 20580</strong>
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>